export default __webpack_public_path__ + "static/media/share-icon-black.ef0efe27.svg";